export const servingOptions = [
    {
        name: 'White Rice',
        price: 0
    },
    {
        name: 'Plain Fried Rice',
        price: 0.5
    },
    {
        name: 'Chicken Fried Rice',
        price: 2
    },
    {
        name: 'Shrimp Fried Rice',
        price: 2
    },
    {
        name: 'Beef Fried Rice',
        price: 2
    },
    {
        name: 'Pork Fried Rice',
        price: 2
    },
    {
        name: 'House Special Fried Rice',
        price: 2.5
    },
    {
        name: 'Lo Mein',
        price: 2.5
    }
];

export const servingOptionsAlt = [
    {
        name: 'White Rice',
        price: 0
    },
    {
        name: 'Plain Fried Rice',
        price: 0
    },
    {
        name: 'Chicken Fried Rice',
        price: 2
    },
    {
        name: 'Shrimp Fried Rice',
        price: 2
    },
    {
        name: 'Beef Fried Rice',
        price: 2
    },
    {
        name: 'Pork Fried Rice',
        price: 2
    },
    {
        name: 'House Special Fried Rice',
        price: 2.5
    },
    {
        name: 'Lo Mein',
        price: 2.5
    }
];